import Visibility from '@src/elements/Visibility';
import classNames from 'classnames';
import React from 'react';
import { HeroSmallFragment } from '@src/graphql/gql-types';
import styles from './HeroSmall.module.scss';
import HeroContent from '@src/components/HeroContent';
import Heading from '@src/elements/Heading';
import { Container } from '@src/elements/Grid';
import MediaImage from '@src/components/MediaImage';
import { WordDictionary } from '@src/types/dictionary';
import { replaceStringWithDictionary } from '@src/utils/strings';
import NewsEventsTabs from '../NewsEventsTab/NewsEventsTab';
import { SunraySVG } from '@src/svgs';
import { COLOR_LIME } from '@src/types/colors';

type HeroSmall = Partial<HeroSmallFragment> & {
  isCentered?: boolean;
  replacementDictionary?: WordDictionary;
  isCommunityNewsEvents?: boolean;
} & React.HTMLProps<HTMLElement>;

const HeroSmall: React.FC<HeroSmall> = ({
  heading,
  description,
  mediaItem,
  plain,
  isCentered = false,
  children,
  replacementDictionary,
  isCommunityNewsEvents = false
}) => {
  const headingText = replacementDictionary
    ? replaceStringWithDictionary(heading, replacementDictionary)
    : heading;

  const descriptionText = replacementDictionary
    ? replaceStringWithDictionary(description, replacementDictionary)
    : description;
  const mediaImage = mediaItem?.__typename === 'MediaImage' && mediaItem;

  return (
    <>
      {plain ? (
        <div className={styles.heroPlain}>
          <div
            className={classNames({
              [styles.heroPlainCentered]: !!isCentered
            })}
          >
            <div className={styles.plainWrapper}>
              <Heading priority={1} fontStyle="h1">
                {headingText}
              </Heading>
              {descriptionText && (
                <p className={styles.plainDescription}>{descriptionText}</p>
              )}
              {children && (
                <div className={styles.plainDescription}>{children}</div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <>
          <div
            className={classNames(styles.hero, {
              [styles.heroWithNewsAndEvents]: isCommunityNewsEvents
            })}
          >
            <div className={styles.backgroundMediaWrapper}>
              {mediaImage && (
                <div className={styles.backgroundMedia}>
                  <MediaImage {...mediaImage} priority />
                </div>
              )}
            </div>
            <div className={styles.heroBackground}></div>
            {/* Overlay content on larger devices */}
            <Visibility xs={false} md>
              <div className={styles.heroContentDesktop}>
                <Container className={styles.heroContentContainer}>
                  <div className={styles.heroContentSmallCard}>
                    <HeroContent
                      heading={headingText || ''}
                      description={descriptionText || ''}
                    />
                    <div className={styles.sunrayContainer}>
                      <SunraySVG color={COLOR_LIME} />
                    </div>
                  </div>
                  {isCommunityNewsEvents && <NewsEventsTabs />}
                </Container>
              </div>
            </Visibility>
          </div>
          <Visibility md={false}>
            <div className={styles.heroContentMobile}>
              <Container className={styles.heroContentMobileContainer}>
                <HeroContent
                  heading={headingText || ''}
                  description={descriptionText || ''}
                />
              </Container>
              <div className={styles.sunrayContainer}>
                <SunraySVG color={COLOR_LIME} />
              </div>
              <div className={styles.mobileBackground}> </div>
            </div>
            {isCommunityNewsEvents && <NewsEventsTabs isMobile />}
          </Visibility>
        </>
      )}
    </>
  );
};

export default HeroSmall;
